import { useContext, useEffect, useState } from "react";
import { CompanyDto } from "../../../../dtos/catalogs/company/CompanyDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { CostCalculationMethods } from "../../../../enums/CostCalculationMethods";
import CompanyDetailSkeleton from "./CompanyDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import CompanyDetailMain from "./CompanyDetailMain";
import CompanyDetailContact from "./CompanyDetailContact";

interface IProps {
  model: CompanyDto | null;
  modelUpdatedEvent: (newModel: CompanyDto) => void;
}

interface CompanyModel {
  id: string;
  name: string;
  tin: string;
  legalForm: number;
  registrationDate: Date;
  legalAddress?: string;
  actualAddress?: string;
  phoneNumber?: string;
  email?: string;
  isEmailValid?: boolean;
  prefix?: string;
  costCalculationMethod: CostCalculationMethods;
}

export const CompanyDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<CompanyModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("tin", model.tin);
      setValue("legalForm", model.legalForm);
      setValue("registrationDate", model.registrationDate);
      setValue("legalAddress", model.legalAddress);
      setValue("actualAddress", model.actualAddress);
      setValue("phoneNumber", model.phoneNumber);
      setValue("email", model.email);
      setValue("isEmailValid", model.isEmailValid);
      setValue("prefix", model.prefix);
      setValue("costCalculationMethod", model.costCalculationMethod);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: CompanyModel) => {
    if (action === "save") {
      const newModel: CompanyDto = { ...model, ...data };
      await saveHandler(newModel);
    }
  };

  if (!model) {
    return (
      <>
        <CompanyDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Contacts"} />
        </NFTabs>
        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <CompanyDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <CompanyDetailContact />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
